import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getProduct, editProduct } from "../../store/actions/products_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import { initialValues, inputFields } from "../../shared/enums/products_enum";

const EditProduct = ({
  editProduct,
  getProduct,
  match,
  product: { loading, product },
}) => {
  let history = useHistory();
  useEffect(() => {
    getProduct(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitProduct = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.product_image = images.featured_image;
        }
        if (images.gallery_images && images.gallery_images.length > 0) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editProduct(product.id, values);
    history.push(`/products/${product.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Product"
          mainLinkTitle="Products"
          mainLinkUrl="/products"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              product && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {product.title} - <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link to="/products" className="btn btn-soft-light">
                          <i className="fa fa-angle-left"></i> Products
                        </Link>
                        <Link
                          to={`/products/${product.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={product}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitProduct}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  product: state.product,
});

const mapDispatchToProps = { editProduct, getProduct };

export default connect(mapStateToProps, mapDispatchToProps)(EditProduct);
